<app-digital-spotlight-template-list></app-digital-spotlight-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreateSpotlightTemplateModal()">
    Create Spotlight Template
  </lib-button-primary>
</lib-button-input-portal>
